import { Component } from '@angular/core';
import { UrlParams } from './constants/URL_PARAMS';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent {
    constructor() {
        const lastSlash = window.location.href.split('/', 3).join('/').length;
        const host = window.location.href.substr(0, lastSlash + 1);
        UrlParams.init(host);
    }
    ngOnInit(): void {
    }
}
